import { UserLoginData } from "@/src/types";
import api from "../api";

export async function loginUser(
    userLoginData: UserLoginData
): Promise<any | null> {
    // force email to lowercase
    userLoginData.email = userLoginData.email.toLowerCase();

    return await api
        .post("auth/token/", userLoginData)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}
